module.exports = __webpack_public_path__ + "static/media/Medcare Hospital Sharjah.e1fa32fe.jpg";